import React from "react";

const Privacy = () => {
   return(<h1>This is Privacy</h1>);
};
export default Privacy;